export class ScoreRequest {
    public Answers !: {}
  
    constructor() {}
  
    public getScore(callback: any) {
      const xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4) {
          if(this.status===200){
            callback(this.status, JSON.parse(this.responseText));
          }
          else {
            callback(this.status);
          }
        }
      };
      xhttp.open("POST", "/api/score/AZGACA2017", true);
      xhttp.setRequestHeader("Content-type", "application/json");
  
      xhttp.send(JSON.stringify(this.Answers));
    }
  }
  